import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "car-container",
  ref: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.count, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: ["car", [item > _ctx.data.ratio * _ctx.count && 'light']],
        style: {'transitionDuration': (Math.random() + .5) + 's'},
        key: item
      }, [
        _createVNode("img", {
          src: _ctx.data.img,
          alt: ""
        }, null, 8, ["src"])
      ], 6))
    }), 128))
  ], 512))
}